import React from 'react';
import { Popover, Tooltip } from 'antd';
import AddNodePopover from '../AddNodePopover';
import styles from './index.module.scss';

const BASE_URL = 'https://photostudio-ai-oss.arcsoft.com.cn//photostudio-opshub/FreeCanvas';
const ADMIN_FREE_CANVAS_BASE_URL = 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/freeCanvas';

const TOOLS = [
    { key: 'select', icon: `${BASE_URL}/select.svg`, label: '选择', shortcut: 'V', tooltip: '选择' },
    { key: 'drag', icon: `${BASE_URL}/drag.svg`, label: '移动', shortcut: 'H', tooltip: '移动' },
];

const ACTIONS = [
    { key: 'menu', icon: `${BASE_URL}/menu.svg`, tooltip: '添加节点' },
    { key: 'upload', icon: `${BASE_URL}/upload.svg`, tooltip: '上传图片' },
    { key: 'folder', icon: `${ADMIN_FREE_CANVAS_BASE_URL}/folder.svg`, tooltip: '素材管理库' },
    { key: 'record', icon: `${BASE_URL}/record.svg`, tooltip: '生成记录' },
    { key: 'keyboard', icon: `${ADMIN_FREE_CANVAS_BASE_URL}/keyBoard.svg`, tooltip: '快捷键' },
];

const KEYBOARD_SHORTCUT_GROUPS = [
    {
        title: '操作',
        items: [
            { label: '选择', keys: ['V'] },
            { label: '移动', keys: ['H'] },
        ],
    },
    {
        title: '缩放',
        items: [
            { label: '放大', keys: ['Ctrl', '+'] },
            { label: '缩小', keys: ['Ctrl', '-'] },
            { label: '放大缩小', keys: ['Ctrl', '滚轮'] },
        ],
    },
    {
        title: '移动',
        items: [
            { label: '移动模式下', keys: ['拖拽'] },
            { label: '选择模式下', keys: ['空格', '鼠标拖拽'] },
        ],
    },
    {
        title: '通用',
        items: [
            { label: '撤销', keys: ['Ctrl', 'Z'] },
            { label: '重做', keys: ['Ctrl', 'Shift', 'Z'] },
            { label: '复制卡片/组', keys: ['Ctrl', 'C'] },
            { label: '粘贴卡片/组', keys: ['Ctrl', 'V'] },
            { label: '创建副本', keys: ['Alt', '拖拽'] },
            { label: '删除卡片/组/连线', keys: ['Delete'] },
        ],
    },
];

const renderShortcutKeys = (keys) => (
    <span className={styles.shortcutKeys}>
        {keys.map((key, index) => (
            <React.Fragment key={`${key}-${index}`}>
                {index > 0 ? <span className={styles.shortcutPlus}>+</span> : null}
                <span className={styles.shortcutKey}>{key}</span>
            </React.Fragment>
        ))}
    </span>
);

const keyboardPopoverContent = (
    <div className={styles.shortcutPanel}>
        <div className={styles.shortcutPanelHeader}>快捷键</div>
        <div className={styles.shortcutPanelBody}>
            {KEYBOARD_SHORTCUT_GROUPS.map((group) => (
                <div key={group.title} className={styles.shortcutGroup}>
                    <div className={styles.shortcutGroupTitle}>{group.title}</div>
                    <div className={styles.shortcutGroupList}>
                        {group.items.map((item) => (
                            <div key={`${group.title}-${item.label}`} className={styles.shortcutRow}>
                                <span className={styles.shortcutLabel}>{item.label}</span>
                                {renderShortcutKeys(item.keys)}
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    </div>
);

const CanvasToolbar = ({ activeTool = 'drag', onToolChange, onAction, onAddNode }) => {
    const renderAction = (item) => {
        if (item.key === 'menu') {
            return (
                <AddNodePopover onSelect={onAddNode}>
                    <Tooltip title={item.tooltip} placement="top" overlayClassName={styles.tooltip}>
                        <span className={styles.btn}>
                            <img src={item.icon} alt={item.key} width={20} height={20} />
                        </span>
                    </Tooltip>
                </AddNodePopover>
            );
        }

        if (item.key === 'keyboard') {
            return (
                <Popover
                    content={keyboardPopoverContent}
                    placement="top"
                    trigger="hover"
                    arrow={false}
                    overlayClassName={styles.keyboardPopover}
                    align={{ offset: [0, -6] }}
                >
                    <span className={styles.btn}>
                        <img src={item.icon} alt={item.key} width={20} height={20} />
                    </span>
                </Popover>
            );
        }

        return (
            <Tooltip title={item.tooltip} placement="top" overlayClassName={styles.tooltip}>
                <span
                    className={styles.btn}
                    onClick={() => onAction?.(item.key)}
                >
                    <img src={item.icon} alt={item.key} width={20} height={20} />
                </span>
            </Tooltip>
        );
    };

    return (
        <div className={styles.wrapper}>
            <div className={styles.toolSwitch}>
                {TOOLS.map((tool) => (
                    <Tooltip key={tool.key} title={`${tool.label}    ${tool.shortcut}`} placement="top" overlayClassName={styles.tooltip}>
                        <span
                            className={`${styles.btn} ${activeTool === tool.key ? styles.active : ''}`}
                            onClick={() => onToolChange?.(tool.key)}
                        >
                            <img src={tool.icon} alt={tool.label} width={20} height={20} />
                        </span>
                    </Tooltip>
                ))}
            </div>
            <span className={styles.divider} />
            {ACTIONS.map((item, index) => (
                <React.Fragment key={item.key}>
                    {index === ACTIONS.length - 1 ? <span className={styles.divider} /> : null}
                    {renderAction(item)}
                </React.Fragment>
            ))}
        </div>
    );
};

export default CanvasToolbar;
